<template>
  <div class="d-flex justify-content-start align-items-end mb-2">
    <b-form-group label="Status" class="mr-2">
      <b-form-select v-model="filters.statusId" @change="onSearch">
        <option :value="null">All</option>
        <option v-for="option in sortSelect(quotesStatusOptions)" :key="option.name" :value="option.id">
          {{option.name}}</option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Quote No" class="mr-2">
      <b-form-input v-model="filters.quoteNo" size="sm" type="text" @input="onSearch" />
    </b-form-group>
    <b-form-group label="Customer" class="mr-2">
      <b-form-input v-model="filters.company" size="sm" type="text" @input="onSearch" />
    </b-form-group>
    <b-form-group label="Customer PN" class="mr-2">
      <b-form-input v-model="filters.customerPn" size="sm" type="text" @input="onSearch" />
    </b-form-group>
    <b-form-group label="Sales Rep" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_QUOTE)">
      <!-- <b-form-input v-model="filters.salesRep" size="sm" type="text" @input="onSearch" /> -->
      <b-form-select v-model="filters.salesPersonUserId" @change="onSearch">
        <option :value="null">All</option>
        <option
          v-for="(selectRep, indexRep) in sortSelect(salesReps)"
          :key="indexRep"
          :value="selectRep.id"
        >{{ selectRep.name }}</option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
      <b-form-checkbox v-model="filters.needsAuthorization" :indeterminate.sync="filters.needsAuthorization == null" @input="onSearch" />
    </b-form-group>
    <date-range-picker :dateFrom="filters.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
    <div class="clear-container">
      <b-button size="sm" @click="handleClear">Clear filters</b-button>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import debounce from 'lodash/debounce';

import { SEARCH_DEBOUNCE_TIME, QUOTES_STATUS } from '@/shared/constants';

import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      // quotesStatusOptions:[
      //   { id: 205, name: 'Close' },
      //   { id: 204, name: 'Open' },
      //   { id: 322, name: 'Pending' },
      //   { id: 328, name: 'Lost' },
      // ],
      quotesStatusOptions: QUOTES_STATUS,
    }
  },
  props: {
    filter: Function
  },
  computed: {
    ...mapGetters('quotes', ['filters']),
    ...mapState('salesReps', ['salesReps']),
  },
  methods: {
    ...mapActions('quotes', ['search']),
    ...mapActions('salesReps', ['getSalesReps']),
    // ...mapMutations('quotes', [
    //   'setLastOpenedQuoteId',
    // ]),
    onSearch: debounce(function(data = false) {
      if(typeof data === 'object') { Object.assign(this.filters,data) }
      this.$emit('filter');
      this.search(this.filters);
    }, SEARCH_DEBOUNCE_TIME),
    handleClear() {
      // this.clearFilters();
      this.clearObject(this.filters);
      this.search(this.filters);
      //this.setLastOpenedQuoteId(0);
      // this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
    },
  },
  mounted() {
    if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
      this.clearObject(this.filters);

      this.filters.needsAuthorization = true;
      delete this.$route.params.needsAuthorization;

      this.$emit('filter');
      this.search(this.filters);
    }

    if('quoteStatus' in this.$route.params) {
      this.clearObject(this.filters);

      this.filters.statusId = this.$route.params.quoteStatus;
      delete this.$route.params.quoteStatus;

      this.$emit('filter');
      this.search(this.filters);
    }

    if('dateRangeFilter' in this.$route.params) {
      this.clearObject(this.filters);

      let from_date = this.$route.params.dateRangeFilter.dateFrom;
      let to_date = this.$route.params.dateRangeFilter.dateTo;

      this.filters.dateFrom = from_date;
      this.filters.dateTo = to_date;

      delete this.$route.params.dateRangeFilter;

      this.$emit('filter');
      this.search(this.filters);
    }

    // console.log('this.$route:', this.$route);

    if('salesPersonFilter' in this.$route.params && this.$route.params.salesPersonFilter) {
      this.clearObject(this.filters);

      this.filters.salesPersonUserId = this.$route.params.salesPersonFilter;
      delete this.$route.params.salesPersonFilter;

      this.$emit('filter');
      this.search(this.filters);
    }

    this.getSalesReps();
  }


};
</script>

<style>
.clear-container {
  margin-top: 12px;
  text-align: right;
}
</style>
